import React, { Component } from 'react'

import Logo from '../layouts/v2/header/Logo'

import { Col, Container } from '@amzn/stencil-react-components/layout'
import { PageHeader } from '@amzn/stencil-react-components/page'

class DefaultPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Container>
        <Col margin={{left: "S300", right: "S300"}} gridGap="S600">
          <PageHeader isFullWidth={true} isFixed={true} aria-label="Page Header">
            <Logo/>
          </PageHeader>
          {this.props.children}
        </Col>
      </Container>
    );
  }
}

export default DefaultPage;